<template>
  <div class="report-project">
    <el-tabs v-model="reportTabName" type="card">
      <el-tab-pane label="Transaction" name="transaction">
        <Transaction :company="company_uid" :project="user_project" client="0" v-if="reportTabName==='transaction'"/>
      </el-tab-pane>
      <el-tab-pane label="Project" name="project">
        <Project :company="company_uid" :project="user_project" client="0" v-if="reportTabName==='project'"/>
      </el-tab-pane>
      <el-tab-pane label="Monthly Charge" name="monthly-charge">
        <MonthlyCharge :project="user_project" v-if="reportTabName==='monthly-charge'"/>
      </el-tab-pane>
      <el-tab-pane label="Bank Account" name="bank-account">
        <BankAccount :project="user_project" v-if="reportTabName==='bank-account'"/>
      </el-tab-pane>
      <el-tab-pane label="Compliance" name="compliance">
        <Compliance :project="user_project" v-if="reportTabName==='compliance'"/>
      </el-tab-pane>
      <el-tab-pane label="Debt" name="debt">
        <Debt :project="user_project" v-if="reportTabName==='debt'"/>
      </el-tab-pane>
      <el-tab-pane label="Account Audit" name="account-audit">
        <AccountAudit :project="user_project" v-if="reportTabName==='account-audit'"/>
      </el-tab-pane>
      <el-tab-pane label="Introducer" name="introducer">
        <IntroducerReport :project="user_project" v-if="reportTabName==='introducer'"/>
      </el-tab-pane>
      <el-tab-pane label="Firewall" name="firewall">
        <Firewall :project="user_project" v-if="reportTabName==='firewall'"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Transaction from '@/views/report/components/company-transaction-report'
import Project from '@/views/report/components/project-report'
import MonthlyCharge from "@/views/report/components/monthly-charge-report";
import BankAccount from "@/views/report/components/bank-account-report";
import Compliance from "@/views/report/components/compliance-report";
import Debt from "@/views/report/components/debt";
import AccountAudit from "@/views/report/components/account-audit-report";
import IntroducerReport from "@/views/report/components/introducer-report";
import Firewall from "@/views/report/components/firewall"
export default {
  components: {
    MonthlyCharge,
    BankAccount,
    Transaction,
    Project,
    Compliance,
    Debt,
    AccountAudit,
    IntroducerReport,
    Firewall
  },
  computed: {
    ...mapGetters(["user_project", "company_uid"]),
    reportRole() {
      return this.roleAuth([this.role.spadmin, this.role.admin]);
    },
  },
  data() {
    return {
      reportTabName: "transaction",
    };
  },
  created() {},
};
</script>

<style lang="scss">
.report-project{
  background-color: white;
  .el-tabs{
    padding-top: 16px;
  }
}
</style>